import * as React from "react";
import { CoughMarshalClient } from "@vitalograph/coughmarshalclient";
import { useAuth } from "react-oidc-context";
import { User } from "oidc-client-ts";
import { GetTokenManually } from "./WebPortalTokenClient";

declare const coughMarshalRootUrl: string;

export const useCoughMarshalApiClient = (abortController?: AbortController) => {
    const auth = useAuth();

    const clientFactory = (user: User) => {
        return new CoughMarshalClient(coughMarshalRootUrl, {
            fetch: (url, init) => {

                const authInit = user?.access_token
                    ? {
                        ...init,
                        credentials: 'same-origin',
                        headers: { ...init?.headers, 'Authorization': `Bearer ${GetTokenManually()?.access_token ?? user?.access_token}` },
                        signal: abortController?.signal,
                    } as RequestInit
                    : init;

                return fetch(url, authInit);
            }
        });
    }

    const [client, setClient] = React.useState<CoughMarshalClient>(clientFactory(auth.user));

    React.useEffect(() => {
        setClient(clientFactory(auth.user));
    }, [auth.user.access_token]);

    return client;
}
